import {HttpClient} from "../../service/httpClient/HttpClient";

export class WorkAndBusinessService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getAllBusinessList(
        id,
        page,
        size,
        languageCode,
        title,
        status
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `location-registration-campaigns/${id}/registrations`,
                {
                    page, size,
                    "language-code": languageCode,
                    title, status
                }
            ).then(resolve).catch(reject)
        })
    }

}